export default __webpack_public_path__ + "static/media/banner-backgroud.3e0ad9e5.png";